import type { Degree, Distance, Point } from "@pdfking/math"
import { Cos, Scale, Sin, Subtract, ToRadians, Total } from "@pdfking/math"
import { HALF_TURN, QUARTER_TURN, ZERO_DISTANCE } from "@pdfking/math/constants"
import { ArcPoints, DrawPath } from "@pdfking/renderer-api"

import type { FolderPath } from "#public"

/** A round-ended slot — a notch, a thumb cut — opening at `base`, `facing`
 * the angle it is cut towards (0 to the right, 90 down): two straight `leg`s,
 * none for a half circle, then a half circle of `radius`. Its size is its
 * own, at any size of the folder. */
export const FolderSlot = (
  base: Point<Distance>,
  facing: Degree,
  radius: Distance,
  leg: Distance = ZERO_DISTANCE
): FolderPath => {
  const [fx, fy] = [Cos(ToRadians(facing)), Sin(ToRadians(facing))]
  const at = (along: Distance, across: Distance): Point<Distance> => ({
    x: Subtract(Total(base.x, Scale(along, fx)), Scale(across, fy)),
    y: Total(base.y, Scale(along, fy), Scale(across, fx)),
  })
  const arc = ArcPoints(
    at(leg, ZERO_DISTANCE),
    radius,
    Total(facing, QUARTER_TURN),
    Scale(HALF_TURN, -1)
  )
  return {
    points: leg
      ? [
          ...DrawPath([at(ZERO_DISTANCE, radius)]),
          ...arc,
          ...DrawPath([at(ZERO_DISTANCE, Scale(radius, -1))]),
        ]
      : arc,
    closed: false,
  }
}
